import React from 'react'
import './Video.css'

function Video({ embedId }) {
    return (
        <div className="v">
            <h1 className="v-title">Or maybe i'm here</h1>
            <iframe
                src={`https://www.youtube.com/embed/${embedId}`}
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
                title="video"
                className="v-item"
                width="100%"
                height="90vh"
            />{" "}
        </div>
    )
}

export default Video